import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';
import SimpleMenuParallax from '../../components/Parallax/SimpleMenuParallax';
import { Paper, Button, CircularProgress, TextField } from '@material-ui/core';
import Card from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import {
    formatCreditCardNumber,
    formatExpirationDate,
    formatCVC,
    formatFormData,
    PAYMENT_PENDING,
    STRIPE_SECRET_KEY
} from '../../utils/config/constants';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import HOCLoader from '../../components/HOC/HOCLoader';
import { NotificationManager } from 'react-notifications';
import { FormattedMessage, injectIntl } from 'react-intl';
import { validateCreditCardForm } from '../../utils/validators/validateForm';
import DeleteAlert from '../../components/Alert/DeleteAlert';
import CardComponect from './CardComponect';


class AddNewCard extends Component {
    constructor(props) {
        console.log("cards props", props)
        super();
        this.state = {
            number: '',
            name: '',
            expiry: '',
            cvc: '',
            issuer: '',
            focused: '',
            formData: null,
            cardtoken: null,
            booking: '',
            redirectBookingSuccess: false,
            loaderButton: false,
            deleteAlert: false,
            cardSelected: '',
            acceptLoadingButton: false,
            value: props.history.location.state !== undefined ? props.history.location.state.value : '',
            loginPath: props.history.location.state !== undefined ? props.history.location.state.loginPath : '',
            booking_data: props.history.location.state !== undefined ? props.history.location.state.booking_data : '',
            taskData: props.history.location.state !== undefined ? props.history.location.state.taskData : '',
            taskDataFromConfirmPage: props.history.location.state !== undefined ? props.history.location.state.taskDataFromConfirmPage : ''
        };
    }

    componentDidMount() {
        this.props.cardListAction(this.onCardlistDone);
    }

    onCardlistDone = (success, data) => {
        if (success) {
            this.setState({ cardListNew: data.sources.data[0] });
        }
        console.log("CARDDDDDDSSS NEWWWWWW", this.state.cardListNew);
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ booking: data.data });
        }
    };
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button
                    className="custom-button"
                    onClick={this.addNewCard}
                >
                    <FormattedMessage id="payment.add" defaultMessage="Add" />
                </button>
            );
        }
    };
    addNewCard = (token) => {

        this.setState({ loaderButton: true });
        this.props.cardAddAction(
            token,
            this.onDoneAdding
        );

    };

    handleError = params => {
        this.setState(params);
    };

    onDoneAdding = (success, data) => {
        this.setState({ loaderButton: false });
        console.log(this.state);
        console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX", this.state);

        if (success && this.state.loginPath === 'BookingConfirmPaymentLogin') {
            this.props.history.push(`/user/booking_confirm`, {
                taskData: this.state.taskData,
                booking_data: this.state.booking_data,
                taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage,
                BookingPath: this.props.history.location.state.BookingPath
            });
        }
        else if (success) {
            // If success but not 'BookingConfirmPaymentLogin'
            this.props.redirectToList();
            NotificationManager.success(
                <FormattedMessage
                    id="cardAddedSuccess"
                    defaultMessage="Card added successfully"
                />,
                'Success'
            );
        } else {
            this.props.redirectToList();
        }
    };

    handleCallback = ({ issuer }, isValid) => {
        if (isValid) {
            this.setState({ issuer });
        }
    };

    handleInputFocus = ({ target }) => {
        this.setState({
            focused: target.name
        });
    };

    handleInputChange = ({ target }) => {
        if (target.name === 'number') {
            this.setState({ numberError: '' });
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === 'expiry') {
            target.value = formatExpirationDate(target.value);
            this.setState({ expiryError: '' });
        } else if (target.name === 'cvc') {
            target.value = formatCVC(target.value);
            this.setState({ cvcError: '' });
        } else if (target.name === 'name') {
            target.value = target.value;
            this.setState({ nameError: '' });
        }
        this.setState({ [target.name]: target.value });
    };

    handleSubmit = e => {
        e.preventDefault();
        const { issuer } = this.state;
        const formData = [...e.target.elements]
            .filter(d => d.name)
            .reduce((acc, d) => {
                acc[d.name] = d.value;
                return acc;
            }, {});

        this.setState({ formData });
        this.form.reset();
    };
    payViaCard = cardId => {
        if (this.state.booking.payment_status === PAYMENT_PENDING) {
            this.setState({ acceptLoadingButton: true });
            this.props.payViaCardAction(
                {
                    cardId: cardId,
                    bookingToken: this.state.booking.token
                },
                this.onPaymentDone
            );
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="paymentAlreadyDone"
                    defaultMessage="Payment is already done"
                />,
                'Error'
            );
        }
    };
    onPaymentDone = (success, data) => {
        this.setState({ acceptLoadingButton: false });
        if (success) {
            NotificationManager.success(data.message, 'Success');
            this.setState({ redirectBookingSuccess: true });
        }
    };

    alertDeleteCard = cardId => {
        this.setState({ deleteAlert: true, cardSelected: cardId });
    };

    handleYes = () => {
        this.setState({ deleteAlert: false });
        this.deleteCard(this.state.cardSelected);
    };
    handleNo = () => {
        this.setState({ deleteAlert: false });
    };

    deleteCard = cardId => {
        this.props.deleteCardAction(
            {
                cardToken: cardId
            },
            this.onDeleteDone
        );
    };
    onDeleteDone = (success, data) => {
        if (success) {
            NotificationManager.success(data.message, 'Success');
        }
    };
    handleClose = () => {
        this.props.redirectToList();
    };

    render() {
        const {
            name,
            number,
            expiry,
            cvc,
            focused,
            issuer,
            formData,
            numberError,
            expiryError,
            cvcError,
            nameError
        } = this.state;
        const { formatMessage } = this.props.intl;
        if (this.state.redirectBookingSuccess) {
            this.props.history.push({
                pathname: `/user/booking_confirm/`
            });
        }
        return (
            <div>
                <HOCLoader loading={this.props.cardLoader}>
                    <div>
                        <div className="ds-boar-title justify-content-between d-flex mb-4 mt-5">
                            <h2 className="mb-0">
                                <FormattedMessage
                                    id="payment.addnew"
                                    defaultMessage="Add new credit card"
                                />
                            </h2>
                            {this.props.showManageCards && (
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={this.handleClose}
                                >
                                    <FormattedMessage
                                        id="manageCards"
                                        defaultMessage="Manage Cards"
                                    />
                                </Button>
                            )}
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-xl-6">
                                <Card
                                    number={number}
                                    name={name}
                                    expiry={expiry}
                                    cvc={cvc}
                                    focused={focused}
                                    callback={this.handleCallback}
                                />
                            </div>
                            <div className="col-sm-12 col-md-12 col-xl-6 cpn-pag-form">
                                <CardComponect finalToken={this.addNewCard} />
                            </div>
                        </div>
                    </div>
                </HOCLoader>
            </div>
        );
    }
}
const mapStateToProps = ({ bookings }) => {
    return { cardList: bookings.cardList, cardLoader: bookings.cardLoader };
};
const composedComponent = compose(
    withTheme(),
    connect(mapStateToProps, actions)
);
export default composedComponent(injectIntl(withRouter(AddNewCard)));



// WEBPACK FOOTER //
// ./src/components/Booking/AddNewCard.jsx